<template>
  <b-table
    class="sticky-table-header"
    :data="productChangeLogs"
    narrowed
    hoverable
  >
    <b-table-column
      field="createdAt"
      :label="$t('productChangeLogs.date')"
      sortable
      v-slot="props"
    >
      {{ formatChangeDate(props.row.createdAt) }}
    </b-table-column>

    <b-table-column
      field="operatorName"
      :label="$t('productChangeLogs.operator')"
      sortable
      v-slot="props"
      >{{ props.row.operatorName || "-" }}</b-table-column
    >

    <b-table-column
      field="storeName"
      :label="$t('common.store')"
      sortable
      v-slot="props"
    >
      <span v-if="props.row.storeName">{{ props.row.storeName }}</span>
      <span v-else class="log-detail">
        {{ $t("productChangeLogs.everyStore") }}
      </span>
    </b-table-column>

    <b-table-column
      field="productName"
      :label="$t('productChangeLogs.item')"
      sortable
      v-slot="props"
    >
      {{ props.row.productName || "-" }}
      <br />
      <span class="log-detail">{{ props.row.barcode }}</span>
    </b-table-column>

    <b-table-column
      field="field"
      :label="$t('productChangeLogs.field')"
      sortable
      v-slot="props"
      >{{ translateChange("fields", props.row.field) }}</b-table-column
    >

    <b-table-column
      field="valueBefore"
      :label="$t('productChangeLogs.valueBefore')"
      v-slot="props"
    >
      <span class="value-before">
        {{ formatChangeValue(props.row.valueBefore, props.row.field) }}
      </span>
    </b-table-column>

    <b-table-column
      field="valueAfter"
      :label="$t('productChangeLogs.valueAfter')"
      v-slot="props"
    >
      <span class="value-after">
        {{ formatChangeValue(props.row.valueAfter, props.row.field) }}
      </span>
    </b-table-column>

    <b-table-column
      field="platform"
      :label="$t('productChangeLogs.origin')"
      sortable
      v-slot="props"
      >{{ translateChange("platforms", props.row.platform) }}</b-table-column
    >

    <template slot="empty"
      ><table-empty-template
    /></template>
  </b-table>
</template>

<script>
import { productChangeLog } from "../../mixins/productChangeLog";
import tableEmptyTemplate from "../common/TableEmptyTemplate";

export default {
  props: ["productChangeLogs"],

  mixins: [productChangeLog],

  components: { tableEmptyTemplate }
};
</script>

<style scoped>
.log-detail {
  font-size: 0.75rem;
  color: hsl(0, 0%, 48%);
}
.value-before {
  color: hsl(0, 0%, 48%);
}
.value-after {
  font-weight: 600;
}
</style>
